<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12.5002C23 18.2992 18.299 23.0002 12.5 23.0002C6.70101 23.0002 2 18.2992 2 12.5002C2 6.70125 6.70101 2.00024 12.5 2.00024C18.299 2.00024 23 6.70125 23 12.5002ZM11.086 12.5005L7.90381 9.31826L9.31802 7.90405L12.5002 11.0863L15.6821 7.90447L17.0963 9.31868L13.9145 12.5005L17.0962 15.6822L15.682 17.0964L12.5002 13.9147L9.31809 17.0969L7.90388 15.6826L11.086 12.5005Z"
      fill="#999999"
    />
  </svg>
</template>

<style scoped lang="postcss"></style>
